import {forwardRef, useImperativeHandle, useState} from 'react'
import {Modal} from 'components/base-modal/Modal'
import {useNotification} from 'hooks/useNotification'

const initialProperties = {
  code: '',
  validity: ''
}

export const ActivationCode = forwardRef((props, ref) => {
  const {ModalProps = {}, onClose = () => {}, onEmailRequest = () => {}} = props
  const [visible, setVisible] = useState(false)
  const [activation, setActivation] = useState(initialProperties)
  const notify = useNotification()

  const [showEmail, setShowEmail] = useState(false)
  const [email, setEmail] = useState('')

  useImperativeHandle(ref, () => ({
    show: _data => {
      setActivation(_data)
      setVisible(true)
    }
  }))

  const onRequestEmail = () => {
    setShowEmail(true)
  }

  const fallbackCopyTextToClipboard = text => {
    var textArea = document.createElement('textarea')
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')

      if (successful) {
        onCopied()
      }
    } catch (err) {
      onCopyError()
    }

    document.body.removeChild(textArea)
  }

  const onCopied = () => {
    notify({
      notification: 'Activation code copied to clipboard',
      variant: 'primary'
    })
  }

  const onCopyError = () => {
    notify({
      notification: 'Oops! Problem copying the activation code.',
      variant: 'danger'
    })
  }

  const onCopyCode = text => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text)
      return
    }

    navigator.clipboard.writeText(text).then(
      () => onCopied(),
      () => onCopyError()
    )
  }

  const onPrintCode = () => {
    window.print()
  }

  return (
    <Modal
      open={visible}
      size="lg"
      onClose={() => {
        setVisible(false)
        onClose()
      }}
      title="Activation Code"
      {...ModalProps}
      center
    >
      <div className="py-4">
        <div className="row print-area">
          <div className="col-md-8 offset-md-2">
            <p>
              You can login the device using 16 digit activation code, valid for single device only. Device
              activation code is valid for 14 days to login.
            </p>
            <input
              style={{fontSize: '2rem', backgroundColor: 'white'}}
              type="text"
              className="form-control form-control-lg text-center"
              value={activation?.code}
              disabled
            />
            <h6 className="text-center mt-2">
              <b>Expires {activation.validity}</b>
            </h6>
          </div>
        </div>

        <div className="vw-popup-box__inner__body__btns">
          <button className="btn btn-primary" onClick={() => onCopyCode(activation?.code)}>
            Copy
          </button>
          <button className="btn btn-primary" onClick={onRequestEmail}>
            Email
          </button>
          <button className="btn btn-primary" onClick={onPrintCode}>
            Print
          </button>
        </div>

        {showEmail && (
          <div className="form-group row mt-4">
            <div className="col-sm-8 col-lg-6 offset-lg-2">
              <input
                type="email"
                className="form-control"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter email to send activation code"
              />
            </div>
            <div className="col-sm-4 col-lg-2">
              <button
                className="btn btn-block btn-outline-primary"
                onClick={() => onEmailRequest(email, activation)}
              >
                <i className="fal fa-paper-plane mr-2"></i> Send
              </button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
})
